<template>
	<tr :class="fxStatus">
		<btn-status-os
			:cod="data.cod"
			:status="data.status"
			:statusContrato="data.statusContrato"
			:codContrato="data.codContrato"
		/>

		<td title="Código">{{ data.cod }}</td>
		<td title="Tarefa">{{ data.titulo }}</td>

		<td title="Previsão de início">
			<i class="fa fa-calendar-check-o"></i>
			<small>{{ data.datas.dInicio | eDate }}</small>
		</td>
		<td title="Previsão de entrega">
			<i class="fa fa-calendar-times-o"></i>
			<small>{{ data.datas.duracao | eDate }}</small>
		</td>
		<td title="Tarefa iniciada em:">
			<i class="fa fa-calendar-check-o"></i>
			<small>{{ data.datas.dComeco | eDate }}</small>
		</td>
		<td title="Tarefa concluída em:">
			<i class="fa fa-calendar-times-o"></i>
			<small>{{ data.datas.dTermino | eDate }}</small>
		</td>
	</tr>
</template>
<script>
	import eDate from 'js/date';
	import BtnStatusOs from './botao-status-os.vue';

	export default {
		props: ['data'],
		components: { BtnStatusOs },
		filters: {
			eDate(val) {
				if (val == '0000-00-00 00:00:00' || val == null) {
					return 'xx/xx/xx';
				} else {
					return eDate(val, 'DD/MM/YY');
				}
			},
		},
		computed: {
			fxStatus() {
				if (this.data.statusContrato == 'suspenso') return 'danger';
				let hoje = new Date();
				let iniPrev = new Date(this.data.datas.dInicio);
				let fimPrev = new Date(this.data.datas.duracao);
				let iniReal = new Date(this.data.datas.dComeco);
				let fimReal = new Date(this.data.datas.dTermino);

				if (this.data.status == 0) {
					if (hoje > iniPrev) return 'warning';
					else return '';
				} else if (this.data.status == 1) {
					if (iniReal > iniPrev) return 'warning';
					else if (hoje > fimPrev) return 'warning';
					else return 'info';
				} else {
					if (iniReal > iniPrev) return 'warning';
					else if (fimReal > fimPrev) return 'warning';
					else return 'success';
				}
			},
		},
	};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/ModeAgroup/components/item-tarefa.vue